<script>
import Form from '@classes/Form'
import { authService } from '@services/safehaven/AuthService'
import { userService } from '@services/UserService'
import moment from 'moment'

export default {
  page: {
    title: 'Code Retrieval',
    meta: [{ name: 'description', content: 'The Code Retrieval page.' }],
  },
  components: {},
  data() {
    return {
      valid: false,
      receivedError: false,
      errorMessage: '',
      showSuccess: false,
      iconCalender: 'mdi-calendar-blank',
      showForm: false,
      date: '',
      currentDateWithFormat: new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, '-'),

      selectDate: null,
      message: '',
      form: new Form({
        fname: '',
        lname: '',
        dob: '',
      }),
      fnameRule: [
        (v) => !!v || 'First name is required',
        (v) => /^[a-zA-Z]+$/g.test(v) || 'Invalid name format',
      ],

      lnameRule: [
        (v) => !!v || 'Last name is required',
        (v) => /^[a-zA-Z]+$/g.test(v) || 'Invalid name format',
      ],

      dobRule: [
        (v) => !!v || 'Date of birth is required',
        (v) =>
          /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/.test(v) ||
          'Invalid date format',
      ],
    }
  },
  computed: {
    computedDateFormatted() {
      if (this.currentDateWithFormat === this.date) {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      } else {
        return this.date ? moment(this.date).format('MM/DD/yyyy') : ''
      }
    },
  },

  created: function() {
    this.mounted()
  },
  methods: {
    async mounted() {
      try {
        const optionsData = (await userService.options()).data
        if (optionsData) {
          this.genderOptions = optionsData.gender
        }
      } catch (error) {
        console.warn(error.response)
      }
    },

    validate() {
      this.$refs.form.validate()
      if (this.valid && this.$refs.form.validate()) {
        this.codeRetrieval()
      }
    },
    async codeRetrieval() {
      var dateDOB = document.getElementById('pickerText').value
      try {
        const orgDetails = JSON.parse(
          localStorage.getItem('organisationDetails')
        )
        const responseData = await authService.codeRetrieval({
          org_id: orgDetails.org,
          first_name: this.form.fname,
          last_name: this.form.lname,
          DOB: moment(dateDOB).format('MM/DD/YYYY'),
        })
        if (responseData && responseData.status === 200) {
          this.$refs.form.reset()
          this.showSuccess = true
          this.message = responseData.data
        } else {
          this.errorMessage = 'Something went wrong'
        }
      } catch (error) {
        this.receivedError = true
        this.errorMessage = error.response.data
        this.showSuccess = false
        this.message = error.response.data
      }
    },
  },
}
</script>

<template>
  <v-container fluid>
    <v-row v-if="!showSuccess" no-gutters class="mb-2">
      <v-col cols="12" md="12" :class="$style.title">
        Resend Access Code
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="mt-3"
        xl="10"
        lg="12"
        justify="center"
        :class="$style.heading"
      >
        Please enter your information below to receive a new code.
      </v-col>
    </v-row>
    <v-row v-if="showSuccess" no-gutters justify="center" class="mb-2">
      <v-col cols="12" md="12" align="center" :class="$style.title">
        Thank you
      </v-col>
      <v-col
        cols="12"
        md="12"
        class="mt-3"
        xl="10"
        lg="12"
        justify="center"
        :class="$style.heading"
      >
        Your information has been submitted.
      </v-col>
    </v-row>
    <v-row v-if="!showSuccess" no-gutters justify="center">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        :class="$style.form"
        @submit.prevent="validate"
      >
        <v-row justify="center">
          <v-col cols="12" md="12" :class="$style.text" class="py-0">
            <div class="mb-2" :class="$style.label"
              >First Name<span :class="$style.mandatory">*</span></div
            >
            <v-text-field
              v-model="form.fname"
              :rules="fnameRule"
              hide-details="auto"
              dense
              outlined
              @keyup="message = null"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="12" :class="$style.text" class="py-0">
            <div class="mb-2" :class="$style.label"
              >Last Name<span :class="$style.mandatory">*</span></div
            >
            <v-text-field
              v-model="form.lname"
              :rules="lnameRule"
              hide-details="auto"
              dense
              :class="$style.textField"
              outlined
              @keyup="message = null"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="12" :class="$style.text" class="py-0">
            <div :class="$style.label"
              >Date of birth<span :class="$style.mandatory">*</span></div
            >
            <v-menu
              v-model="selectDate"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  id="pickerText"
                  slot="activator"
                  :value="computedDateFormatted"
                  placeholder="MM/DD/YYYY"
                  :append-icon="iconCalender"
                  :rules="dobRule"
                  outlined
                  dense
                  :class="$style.textField"
                  v-on="on"
                  @click:append="on.click"
                  @focus="onChangeInput"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date"
                :max="new Date().toISOString().substr(0, 10)"
                @change=";(selectDate = false), onChangeInput"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
    </v-row>
    <v-col v-if="receivedError" justify="center" :class="$style.errorMessage">
      {{ errorMessage }}
    </v-col>
    <v-row v-if="!showSuccess" no-gutters justify="center">
      <v-col cols="12" align="center">
        <v-fab-transition>
          <v-btn
            type="button"
            class="mt-3 mb-6 primary-btn w-m-90-btn"
            bottom
            @click="validate"
          >
            Submit
          </v-btn>
        </v-fab-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.label {
  font-size: 12px;
  font-weight: 700;
  color: #2c3a4b;
}

.mandatory {
  color: #da1414;
}

.heading {
  margin: 0.5rem auto;
  font-size: 14px;
  color: #2c3a4b;
  text-align: left;
}
.errorMessage {
  font-size: 14px;
  color: #da1414;
  text-align: left;
}
.text {
  padding-left: 20px;
  margin: 0.5rem auto;
  color: #2c3a4b;
}
.title {
  font-size: 18px;
  font-weight: 700;
}
.inlineLink {
  display: inline;
}
.fullWidthBtn {
  width: 70%;
  text-transform: unset !important;
}
.signUpText {
  color: #858c94;
}
.serverErrorMsg {
  margin-top: 14px;
  margin-left: 20px;
  font-size: 12px;
  color: #ca024f;
}

@media screen and (max-width: 960px) {
  .fullWidthBtn {
    width: 80%;
  }
  .heading {
    text-align: center;
  }
}
</style>

<style scoped>
.v-text-field >>> input {
  font-size: 14px !important;
}
</style>
